window.onload = function () {
  jQuery(document).ready(function ($) {
    $(".tab").on("click", function (evt) {
      evt.preventDefault();

      // Remove the "active" class from all other elements with class "tab"
      $(".tab").not(this).removeClass("active");

      // Toggle the "active" class on the clicked tab
      $(this).addClass("active");

      var sel = this.getAttribute("data-toggle-target");
      $(".tab-content").removeClass("active").filter(sel).addClass("active");
    });

    // trip slider
    $(".trip-slider").slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 2000,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    });

    function highlightSection(event) {
      var mouseX = event.pageX;
      var mouseY = event.pageY;

      // Change these values based on your section's position and size
      var sectionX = $(".banner-slider").offset().left;
      var sectionY = $(".banner-slider").offset().top;
      var sectionWidth = $(".banner-slider").width();
      var sectionHeight = $(".banner-slider").height();

      // Check if the mouse is within the section
      if (
        mouseX >= sectionX &&
        mouseX <= sectionX + sectionWidth &&
        mouseY >= sectionY &&
        mouseY <= sectionY + sectionHeight
      ) {
        $(".banner-slider").addClass("highlight-section");
      } else {
        $(".banner-slider").removeClass("highlight-section");
      }
    }

    // Attach the mousemove event to the document
    $(document).on("mousemove", highlightSection);

    // $('.hotspot').click(function() {
    //   $('.hotspot').removeClass('open');
    //   $(this).toggleClass('open');
    //   alert(1)
    // });
    $(".table-sign").mouseenter(function () {
      $(".img-bgg").attr(
        "src",
        "https://cdn.shopify.com/s/files/1/0594/5199/8252/files/img1-new.png?v=1704266120"
      );
      $(".img-bgg").attr(
        "data-src",
        "https://cdn.shopify.com/s/files/1/0594/5199/8252/files/img1-new.png?v=1704266120"
      );
      $(".img-bgg").attr(
        "data-srcset",
        "https://cdn.shopify.com/s/files/1/0594/5199/8252/files/img1-new.png?v=1704266120"
      );
      $(".img-bgg").attr(
        "srcset",
        "https://cdn.shopify.com/s/files/1/0594/5199/8252/files/img1-new.png?v=1704266120"
      );
      $(this).addClass("tooltip-show");
      $(".hover-table").not(this).removeClass("tooltip-show");
    });
    $("html, body").click(function () {
      if (!$(event.target).hasClass("table-sign")) {
        $(".img-bgg").attr(
          "src",
          "https://community-auctions.myshopify.com/cdn/shop/files/HeaderLookbook-new.png?v=1703661599"
        );
        $(".img-bgg").attr(
          "data-src",
          "https://community-auctions.myshopify.com/cdn/shop/files/HeaderLookbook-new.png?v=1703661599"
        );
        $(".img-bgg").attr(
          "data-srcset",
          "https://community-auctions.myshopify.com/cdn/shop/files/HeaderLookbook-new.png?v=1703661599"
        );
        $(".img-bgg").attr(
          "srcset",
          "https://community-auctions.myshopify.com/cdn/shop/files/HeaderLookbook-new.png?v=1703661599"
        );
        $(".hover-table").removeClass("tooltip-show");
      }
    });

    // $(".trip-package").mouseenter(function () {
    //   $(".img-bgg").attr(
    //     "src",
    //     "https://cdn.shopify.com/s/files/1/0594/5199/8252/files/img2.png?v=1704266120"
    //   );
    //   $(".img-bgg").attr(
    //     "data-src",
    //     "https://cdn.shopify.com/s/files/1/0594/5199/8252/files/img2.png?v=1704266120"
    //   );
    //   $(".img-bgg").attr(
    //     "data-srcset",
    //     "https://cdn.shopify.com/s/files/1/0594/5199/8252/files/img2.png?v=1704266120"
    //   );
    //   $(".img-bgg").attr(
    //     "srcset",
    //     "https://cdn.shopify.com/s/files/1/0594/5199/8252/files/img2.png?v=1704266120"
    //   );
    //   $(this).addClass("tooltip-show");
    //   $(".hover-table").not(this).removeClass("tooltip-show");
    // });
    // $("html, body").click(function () {
    //   if (!$(event.target).hasClass("trip-package")) {
    //     $(".img-bgg").attr(
    //       "src",
    //       "https://community-auctions.myshopify.com/cdn/shop/files/HeaderLookbook-new.png?v=1703661599"
    //     );
    //     $(".img-bgg").attr(
    //       "data-src",
    //       "https://community-auctions.myshopify.com/cdn/shop/files/HeaderLookbook-new.png?v=1703661599"
    //     );
    //     $(".img-bgg").attr(
    //       "data-srcset",
    //       "https://community-auctions.myshopify.com/cdn/shop/files/HeaderLookbook-new.png?v=1703661599"
    //     );
    //     $(".img-bgg").attr(
    //       "srcset",
    //       "https://community-auctions.myshopify.com/cdn/shop/files/HeaderLookbook-new.png?v=1703661599"
    //     );
    //     $(".hover-table").removeClass("tooltip-show");
    //   }
    // });

    $(".ring-coin").mouseenter(function () {
      $(".img-bgg").attr(
        "src",
        "https://cdn.shopify.com/s/files/1/0594/5199/8252/files/img3-new.png?v=1704266120"
      );
      $(".img-bgg").attr(
        "data-src",
        "https://cdn.shopify.com/s/files/1/0594/5199/8252/files/img3-new.png?v=1704266120"
      );
      $(".img-bgg").attr(
        "data-srcset",
        "https://cdn.shopify.com/s/files/1/0594/5199/8252/files/img3-new.png?v=1704266120"
      );
      $(".img-bgg").attr(
        "srcset",
        "https://cdn.shopify.com/s/files/1/0594/5199/8252/files/img3-new.png?v=1704266120"
      );
      $(this).addClass("tooltip-show");
      $(".hover-table").not(this).removeClass("tooltip-show");
    });
    $("html, body").click(function () {
      if (!$(event.target).hasClass("ring-coin")) {
        $(".img-bgg").attr(
          "src",
          "https://community-auctions.myshopify.com/cdn/shop/files/HeaderLookbook-new.png?v=1703661599"
        );
        $(".img-bgg").attr(
          "data-src",
          "https://community-auctions.myshopify.com/cdn/shop/files/HeaderLookbook-new.png?v=1703661599"
        );
        $(".img-bgg").attr(
          "data-srcset",
          "https://community-auctions.myshopify.com/cdn/shop/files/HeaderLookbook-new.png?v=1703661599"
        );
        $(".img-bgg").attr(
          "srcset",
          "https://community-auctions.myshopify.com/cdn/shop/files/HeaderLookbook-new.png?v=1703661599"
        );
        $(".hover-table").removeClass("tooltip-show");
      }
    });

    $(".bid-box").mouseenter(function () {
      $(".img-bgg").attr(
        "src",
        "https://cdn.shopify.com/s/files/1/0594/5199/8252/files/img4-new.png?v=1704266120"
      );
      $(".img-bgg").attr(
        "data-src",
        "https://cdn.shopify.com/s/files/1/0594/5199/8252/files/img4-new.png?v=1704266120"
      );
      $(".img-bgg").attr(
        "data-srcset",
        "https://cdn.shopify.com/s/files/1/0594/5199/8252/files/img4-new.png?v=1704266120"
      );
      $(".img-bgg").attr(
        "srcset",
        "https://cdn.shopify.com/s/files/1/0594/5199/8252/files/img4-new.png?v=1704266120"
      );
      $(this).addClass("tooltip-show");
      $(".hover-table").not(this).removeClass("tooltip-show");
    });
    $("html, body").click(function () {
      if (!$(event.target).hasClass("bid-box")) {
        $(".img-bgg").attr(
          "src",
          "https://community-auctions.myshopify.com/cdn/shop/files/HeaderLookbook-new.png?v=1703661599"
        );
        $(".img-bgg").attr(
          "data-src",
          "https://community-auctions.myshopify.com/cdn/shop/files/HeaderLookbook-new.png?v=1703661599"
        );
        $(".img-bgg").attr(
          "data-srcset",
          "https://community-auctions.myshopify.com/cdn/shop/files/HeaderLookbook-new.png?v=1703661599"
        );
        $(".img-bgg").attr(
          "srcset",
          "https://community-auctions.myshopify.com/cdn/shop/files/HeaderLookbook-new.png?v=1703661599"
        );
        $(".hover-table").removeClass("tooltip-show");
      }
    });

    $(".portait-frame").mouseenter(function () {
      $(".img-bgg").attr(
        "src",
        "https://cdn.shopify.com/s/files/1/0594/5199/8252/files/img5-new.png?v=1704266120"
      );
      $(".img-bgg").attr(
        "data-src",
        "https://cdn.shopify.com/s/files/1/0594/5199/8252/files/img5-new.png?v=1704266120"
      );
      $(".img-bgg").attr(
        "data-srcset",
        "https://cdn.shopify.com/s/files/1/0594/5199/8252/files/img5-new.png?v=1704266120"
      );
      $(".img-bgg").attr(
        "srcset",
        "https://cdn.shopify.com/s/files/1/0594/5199/8252/files/img5-new.png?v=1704266120"
      );
      $(this).addClass("tooltip-show");
      $(".hover-table").not(this).removeClass("tooltip-show");
    });
    $("html, body").click(function () {
      if (!$(event.target).hasClass("portait-frame")) {
        $(".img-bgg").attr(
          "src",
          "https://community-auctions.myshopify.com/cdn/shop/files/HeaderLookbook-new.png?v=1703661599"
        );
        $(".img-bgg").attr(
          "data-src",
          "https://community-auctions.myshopify.com/cdn/shop/files/HeaderLookbook-new.png?v=1703661599"
        );
        $(".img-bgg").attr(
          "data-srcset",
          "https://community-auctions.myshopify.com/cdn/shop/files/HeaderLookbook-new.png?v=1703661599"
        );
        $(".img-bgg").attr(
          "srcset",
          "https://community-auctions.myshopify.com/cdn/shop/files/HeaderLookbook-new.png?v=1703661599"
        );
        $(".hover-table").removeClass("tooltip-show");
      }
    });

    $(".landscape-frame").mouseenter(function () {
      $(".img-bgg").attr(
        "src",
        "https://cdn.shopify.com/s/files/1/0594/5199/8252/files/img6-new.png?v=1704266120"
      );
      $(".img-bgg").attr(
        "data-src",
        "https://cdn.shopify.com/s/files/1/0594/5199/8252/files/img6-new.png?v=1704266120"
      );
      $(".img-bgg").attr(
        "data-srcset",
        "https://cdn.shopify.com/s/files/1/0594/5199/8252/files/img6-new.png?v=1704266120"
      );
      $(".img-bgg").attr(
        "srcset",
        "https://cdn.shopify.com/s/files/1/0594/5199/8252/files/img6-new.png?v=1704266120"
      );
      $(this).addClass("tooltip-show");
      $(".hover-table").not(this).removeClass("tooltip-show");
    });
    $("html, body").click(function () {
      if (!$(event.target).hasClass("landscape-frame")) {
        $(".img-bgg").attr(
          "src",
          "https://community-auctions.myshopify.com/cdn/shop/files/HeaderLookbook-new.png?v=1703661599"
        );
        $(".img-bgg").attr(
          "data-src",
          "https://community-auctions.myshopify.com/cdn/shop/files/HeaderLookbook-new.png?v=1703661599"
        );
        $(".img-bgg").attr(
          "data-srcset",
          "https://community-auctions.myshopify.com/cdn/shop/files/HeaderLookbook-new.png?v=1703661599"
        );
        $(".img-bgg").attr(
          "srcset",
          "https://community-auctions.myshopify.com/cdn/shop/files/HeaderLookbook-new.png?v=1703661599"
        );
        $(".hover-table").removeClass("tooltip-show");
      }
    });

    $(".pano-item").mouseenter(function () {
      $(".img-bgg").attr(
        "src",
        "https://cdn.shopify.com/s/files/1/0594/5199/8252/files/img7-new.png?v=1704266120"
      );
      $(".img-bgg").attr(
        "data-src",
        "https://cdn.shopify.com/s/files/1/0594/5199/8252/files/img7-new.png?v=1704266120"
      );
      $(".img-bgg").attr(
        "data-srcset",
        "https://cdn.shopify.com/s/files/1/0594/5199/8252/files/img7-new.png?v=1704266120"
      );
      $(".img-bgg").attr(
        "srcset",
        "https://cdn.shopify.com/s/files/1/0594/5199/8252/files/img7-new.png?v=1704266120"
      );
      $(this).addClass("tooltip-show");
      $(".hover-table").not(this).removeClass("tooltip-show");
    });
    $("html, body").click(function () {
      if (!$(event.target).hasClass("pano-item")) {
        $(".img-bgg").attr(
          "src",
          "https://community-auctions.myshopify.com/cdn/shop/files/HeaderLookbook-new.png?v=1703661599"
        );
        $(".img-bgg").attr(
          "data-src",
          "https://community-auctions.myshopify.com/cdn/shop/files/HeaderLookbook-new.png?v=1703661599"
        );
        $(".img-bgg").attr(
          "data-srcset",
          "https://community-auctions.myshopify.com/cdn/shop/files/HeaderLookbook-new.png?v=1703661599"
        );
        $(".img-bgg").attr(
          "srcset",
          "https://community-auctions.myshopify.com/cdn/shop/files/HeaderLookbook-new.png?v=1703661599"
        );
        $(".hover-table").removeClass("tooltip-show");
      }
    });
  });

  $(".hover-table").hover(
    function () {
      $(".banner-slider").addClass("highlight");
    },
    function () {
      $(".banner-slider").removeClass("highlight");
    }
  );


  $(".drive-five-mob").click(function () {
    $('.mob-box-1').addClass("tooltip-show");
    $(".hover-box-mob").not('.mob-box-1').removeClass("tooltip-show");
  });
  $('.tooltip-close-btn').click(function (){
    $(this).parent().removeClass("tooltip-show");
  });
    $(".trip-give-mob").click(function () {
    $('.mob-box-2').addClass("tooltip-show");
    $(".hover-box-mob").not('.mob-box-2').removeClass("tooltip-show");
  });
  $(".portait-mob").click(function () {
    $('.mob-box-3').addClass("tooltip-show");
    $(".hover-box-mob").not('.mob-box-3').removeClass("tooltip-show");
  });
  $(".landscape-mob").click(function () {
    $('.mob-box-4').addClass("tooltip-show");
    $(".hover-box-mob").not('.mob-box-4').removeClass("tooltip-show");
  });
  $(".panorama-mob").click(function () {
    $('.mob-box-5').addClass("tooltip-show");
    $(".hover-box-mob").not('.mob-box-5').removeClass("tooltip-show");
  });
  $(".ring-coin-mob").click(function () {
    $('.mob-box-6').addClass("tooltip-show");
    $(".hover-box-mob").not('.mob-box-6').removeClass("tooltip-show");
  });
  $(".bid-mat-mob").click(function () {
    $('.mob-box-7').addClass("tooltip-show");
    $(".hover-box-mob").not('.mob-box-7').removeClass("tooltip-show");
  });


   
  
};


$(document).ready(function () {
  
// $("#shop-slider-two").owlCarousel({
//     loop: true,
//     margin: 30,
//     autoplay: true,
//     autoplayTimeout: 5000,
//     nav: true,
//     dots: false,
//     autoplaySpeed: 500,
//     navText: ["<i class='fa-solid fa-arrow-left'></i>", "<i class='fa-solid fa-arrow-right'></i>"],
//     responsive: {
//       0: {
//         items: 1,
//         nav: false,
//       },
//       640: {
//         items: 2,
//       },
//       991: {
//         items: 3,
//       },
//       1200: {
//         items: 4,
//       }
//     }
//   });







});





